import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, resolveMediaUrl } from '../lib/api';
import { useLanguage } from '../context/LanguageContext';

export default function ProfileDetail() {
  const { userId } = useParams();
  const [profile, setProfile] = useState(null);
  const [posts, setPosts] = useState([]);
  const [friendStatus, setFriendStatus] = useState('none');
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();

  const loadProfile = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/profile/${userId}`);
      setProfile(response.data?.user);
      setFriendStatus(response.data?.friendStatus || 'none');
    } catch (err) {
      setProfile(null);
    } finally {
      setLoading(false);
    }
  };

  const loadPosts = async () => {
    try {
      const response = await api.get(`/getPostsByUserId/${userId}`);
      setPosts(response.data || []);
    } catch (err) {
      setPosts([]);
    }
  };

  useEffect(() => {
    loadProfile();
    loadPosts();
  }, [userId]);

  const sendRequest = async () => {
    try {
      await api.post('/send', { receiverId: userId });
      setFriendStatus('request_sent');
    } catch (err) {
      // ignore
    }
  };

  const avatar = resolveMediaUrl(profile?.userImage);

  return (
    <div className="list">
      <div className="card">
        {loading ? <p className="muted">{t('common.loading')}</p> : null}
        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          <div className="brand-mark">{profile?.nickName?.slice(0, 1)?.toUpperCase() || 'A'}</div>
          {avatar ? <img src={avatar} alt="avatar" style={{ width: 68, height: 68, borderRadius: 18 }} /> : null}
          <div>
            <h2 className="section-title" style={{ margin: 0 }}>{profile?.name} {profile?.surname}</h2>
            <div className="muted">@{profile?.nickName}</div>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            {friendStatus === 'none' ? (
              <button className="btn btn-primary" type="button" onClick={sendRequest}>
                {t('actions.friendRequest')}
              </button>
            ) : (
              <span className="tag">{friendStatus.replace('_', ' ')}</span>
            )}
          </div>
        </div>
      </div>

      <div className="card">
        <h3 className="section-title">{t('profile.postsUser')}</h3>
        <div className="post-grid">
          {posts.map((post) => {
            const mediaUrl = resolveMediaUrl(post.mediaType === 'video' ? post.video : post.image);
            return (
              <div key={post._id} className="post-card">
                {post.mediaType === 'video' ? (
                  <video src={mediaUrl} controls />
                ) : (
                  <img src={mediaUrl} alt="post" />
                )}
                <div style={{ padding: 12 }}>{post.description}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
